var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ui container", attrs: { id: "metadata-container" } },
    [
      _c("page-navigation-component"),
      _vm._v(" "),
      0 < _vm.getObservationsCount
        ? _c("div", { staticClass: "table-headers" }, [
            _c(
              "div",
              {
                staticClass: "table-header",
                staticStyle: { width: "100px", "margin-left": "40px" }
              },
              [_vm._v("Producer")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-header", staticStyle: { width: "150px" } },
              [_vm._v("Station")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-header", staticStyle: { width: "175px" } },
              [_vm._v("Dataset")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-header", staticStyle: { width: "350px" } },
              [_vm._v("Variable (unit)")]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { id: "observation-list" } },
        _vm._l(_vm.getObservations, function(obs, index) {
          return _c(
            "div",
            { key: index },
            [
              _c("observation-metadata-layout-component", {
                staticClass: "ui content message table-row",
                staticStyle: { padding: "5px" },
                attrs: { id: obs.documentId, observation: obs },
                nativeOn: {
                  click: function($event) {
                    return _vm.metaObsClicked($event)
                  }
                }
              })
            ],
            1
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }